import { getAxiosClient } from "../../../services/HttpsService";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Folder } from "./folders-interface";

export const fetchFoldersByApplication = createAsyncThunk(
  "folders/fetchFoldersByApplication",
  async (appUuid: string) => {
    const client = getAxiosClient();
    const response = await client.get(`api/eza_app_folder/app-uuid/${appUuid}`);
    return response.data as Folder[];
  }
);
